/** Valor centinela para "Todos/Todas" en los filtros de Tarjeta. */
export const CARD_ALL_VALUE = 'all';

/**
 * Estatus de tarjeta (valores del BE). El catálogo del BE manda; estas
 * constantes son solo el fallback si el catálogo no llega.
 */
export const CARD_STATUS_FILTERS = [
  { value: 'enabled', labelKey: 'dashboard.card.status.active' },
  { value: 'blocked', labelKey: 'dashboard.card.status.blocked' },
  { value: 'disabled', labelKey: 'dashboard.card.status.inactive' },
] as const;

/**
 * Tipo de tarjeta. Fuente actual: constante; se sustituye por el catálogo del BE
 * cuando aterrice BF-623 (seam).
 */
export const CARD_TYPE_FILTERS = [
  { value: 'physical', labelKey: 'dashboard.card.type.physical' },
  { value: 'virtual', labelKey: 'dashboard.card.type.virtual' },
] as const;
